<template>
    <header class="header">{{ header }}</header>
</template>

<script>
export default {
    props: {
        header: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    height: 51px;
    line-height: 50px;
    text-align: center;

    border-bottom: 1px solid #ccc;
    box-sizing: border-box;
}
</style>
